module.exports = __webpack_public_path__ + "img/canvas.a789a62e.png";